module.exports = __webpack_public_path__ + "img/Friends_Testament_KJV_1.png";